import PickerStorage from './PickerStorage.vue'

export default PickerStorage
